// Short cues to glance at while telling a story out loud (TK-3204 "Record
// this version" / "Use talking points"). The API's `talking_points` mode
// writes them; this is the prototype's `heuristicPoints`, used until the
// model answers and whenever it cannot: the first words of each sentence.

const ABBREVIATIONS = /\b(Mr|Mrs|Ms|Dr|St)\./g
// U+2024 ONE DOT LEADER stands in for an abbreviation's period so the
// sentence split does not break on it.
const DOT_LEADER = '\u2024'
const MAX_POINTS = 8
const WORDS_PER_POINT = 9

export const heuristicPoints = text => {
  const safe = (text || '').replace(ABBREVIATIONS, `$1${DOT_LEADER}`)
  // Sentences end at .!? or at the end of the text, so a last sentence the
  // writer never punctuated still gets its cue.
  const sentences = safe.match(/[^.!?]+(?:[.!?]+|$)/g) || []

  return sentences.slice(0, MAX_POINTS).flatMap(sentence => {
    const words = sentence.trim().replace(/[.!?]+$/, '').replace(/^(and|but|so|then)\s+/i, '').split(/\s+/).filter(Boolean)

    if (!words.length) return []

    const point = words.slice(0, WORDS_PER_POINT).join(' ').replace(/[,;:]$/, '').replace(new RegExp(DOT_LEADER, 'g'), '.')

    return [`${point.charAt(0).toUpperCase()}${point.slice(1)}${words.length > WORDS_PER_POINT ? '\u2026' : ''}`]
  })
}
